import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from 'src/app/core/route.service';
import { MigrationExpertComponent } from './sp-migration-expert.component';

const routes: Routes = Route.withShell([
  { path: 'appinfo', component: MigrationExpertComponent, data: { title: 'appinfo' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)]
  ],
  exports: [RouterModule],
  declarations: []
})
export class MigrationExpertRoutingModule { }
